import React from 'react';
import { ConnectedPageListItem } from './partials/ConnectedPageListItem/ConnectedPageListItem';
import { IConnectedPage } from '../../../../types/api/connectedPages/IConnectedPage';
import { useSetInitialOpenPages } from '../useSetInitialOpenPages/useSetInitialOpenPages';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import bem from '../../../../lib/bemUtils/bem';

export enum ConnectedPagesTreeModifier {
  COUNTER = 'counter',
}

type ConnectedPagesTreeProps = {
  connectedPages?: IConnectedPage[];
  initialVisibleDepth: number;
  modifier?: Modifier<ConnectedPagesTreeModifier>;
};

export function ConnectedPagesTree({ connectedPages = [], initialVisibleDepth, modifier }: ConnectedPagesTreeProps) {
  useSetInitialOpenPages(connectedPages, initialVisibleDepth);

  return (
    <ul className={bem('connected-pages-tree', modifier)}>
      {connectedPages.map(page => (
        <ConnectedPageListItem key={`pageLink-${page.pageLink.url}`} page={page} />
      ))}
    </ul>
  );
}
